import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { RootState } from '@/store/index';
import { updateUserBssFormApiCall, uploadImage } from '@/services/api'
import { setProfileStepNo } from "@/store/slices/profile/profileStepNo"
import { updateProfileFields } from "@/store/slices/profile/profileSlice"
import { listOfSections } from "@/pages/profile/sections/bssDetails/constants"
import { FOLDER_PATHS, FILE_NAME } from "@/constants/imageFolderPaths";
import Toast from '@/components/common/toast/toast'

import moment from "moment";

import { dataURLtoBlob, getCountryByValue, formatNumberInputWithSpaceAfter5Numbers, undo_formatNumberInputWithSpaceAfter5Numbers, removeLeadingPlus } from "@/utils"

import BssDetailsView from './view'
import { idVerificationProofStatus } from '@/pages/profile/sections/idVerification/constants';

export default function BssDetails() {
    const { common } = useLocalTranslation();
    const dispatch = useDispatch()
    const profileDetails = useSelector((state: RootState) => state.profileReducer.profile);
    const profileStepNo = useSelector((state: RootState) => state.profileStepNoReducer.profileStepNo);

    const [errMsg, setErrMsg] = useState("")
    const [isSubmitBtnLoading, setIsSubmitBtnLoading] = useState(false)

    const [guardianName, setGuardianName] = useState("")
    const [guardianCountryCode, setGuardianCountryCode] = useState<any>(null)
    const [guardianContactNumber, setGuardianContactNumber] = useState("")

    const [bloodGroup, setBloodGroup] = useState<any>(null)
    const [ugDegree, setUgDegree] = useState<any>(null)

    const [underGraduateInstituteName, setUnderGraduateInstituteNameInstituteName] = useState("")
    const [underGraduateInstituteAddress, setUnderGraduateInstituteAddressInstituteAddress] = useState("")

    const [registrationNumber, setRegistrationNumber] = useState("")
    const [passingYear, setPassingYear] = useState<any>(null)

    const [aadharCard, setAadharCard] = useState("")
    const [panCard, setPanCard] = useState("")
    const [otherDocs, setOtherDocs] = useState("")
    const [signature, setSignature] = useState("")
    const [placeOfSignature, setPlaceOfSignature] = useState("")
    const [dateOfSignature, setDateOfSignature] = useState("")
    const [bssAcknowledged, setBssAcknowledged] = useState(false)

    const [toastVisible, setToastVisible] = useState(false);

    useEffect(() => {
        updateBasicDetails()
    }, [profileDetails])

    useEffect(() => {
        setErrMsg('')
        if (profileStepNo === 11) {
            showToast()
        }
    }, [profileStepNo])


    const updateBasicDetails = () => {
        // debugger
        if (profileDetails.bssForm) {
            const bss = profileDetails.bssForm

            setGuardianName(bss.guardianName)

            // debugger
            let countryDetails = null
            if (bss.guardianCountryCode) {
                const guardianCountryCode_ = removeLeadingPlus(bss.guardianCountryCode)
                countryDetails = getCountryByValue(guardianCountryCode_)
            } else {
                countryDetails = getCountryByValue("91")
            }
            if (countryDetails) {
                const guardianCountryCodeCountryCodeObj = {
                    value: countryDetails.value,
                    label: countryDetails.label
                }
                setGuardianCountryCode(guardianCountryCodeCountryCodeObj)
            }

            if (bss.guardianContactNumber) {
                setGuardianContactNumber(formatNumberInputWithSpaceAfter5Numbers(bss.guardianContactNumber))
            }

            if (bss.bloodGroup) {
                const bloodGrpObj = {
                    value: bss.bloodGroup,
                    label: bss.bloodGroup
                }
                setBloodGroup(bloodGrpObj)
            }

            if (bss.underGraduateDegree) {
                const uGDegreeObj = {
                    value: bss.underGraduateDegree,
                    label: bss.underGraduateDegree
                }
                setUgDegree(uGDegreeObj)
            }


            if (bss.underGraduateInstituteName) {
                setUnderGraduateInstituteNameInstituteName(bss.underGraduateInstituteName)
            }
            if (bss.underGraduateInstituteAddress) {
                setUnderGraduateInstituteAddressInstituteAddress(bss.underGraduateInstituteAddress)
            }


            if (bss.registrationNumber) {
                setRegistrationNumber(bss.registrationNumber)
            }

            if (bss.passingYear) {
                const passingYearObj = {
                    value: bss.passingYear,
                    label: bss.passingYear
                }
                setPassingYear(passingYearObj)
            }

            if (bss.aadharCard) {
                setAadharCard(bss.aadharCard)
            }

            if (bss.panCard) {
                setPanCard(bss.panCard)
            }
            if (bss.otherDocs) {
                setOtherDocs(bss.otherDocs)
            }
            if (bss.signature) {
                setSignature(bss.signature)
            }
            if (bss.placeOfSignature) {
                setPlaceOfSignature(bss.placeOfSignature)
            }

            /* 
            This is done to make sure the reducer and the input values are same and additional calls can be ignored
            In handleSubmit2() -> if (profileDetails[source] !== value) ....
            */
            if (bss.dateOfSignature) {
                const formatedDateOfSignature = moment(bss.dateOfSignature).format("YYYY-MM-DD")
                setDateOfSignature(formatedDateOfSignature)
                if (bss.dateOfSignature !== formatedDateOfSignature) {

                    const updateDateOfSignatureInReducer = {
                        dateOfSignature: formatedDateOfSignature
                    }
                    const mergedObj = {
                        ...profileDetails, // 1. Copy all top-level properties from objB
                        bssForm: {
                            ...profileDetails.bssForm, // 2. Copy all existing properties from objB.bssForm
                            ...updateDateOfSignatureInReducer           // 3. Spread all properties from objA here, overwriting duplicates
                        }
                    }

                    dispatch(updateProfileFields(mergedObj))
                }
            }

            if (bss.bssAcknowledged) {
                setBssAcknowledged(bss.bssAcknowledged)
            }

        }
    }

    const handleOnCheckBoxChanged = (e: any, source: string) => {
        const val = e.target.checked
        if (source === "bssAcknowledged") {
            setBssAcknowledged(val)
        }
    }

    const handleInputChange = (e: any, source: string) => {
        setErrMsg('')
        const val = e.target.value
        if (source === listOfSections.guardianName) {
            setGuardianName(val);
        } else if (source === listOfSections.guardianDetails.guardianCountryCode) {
            const countryDetails = getCountryByValue(val)
            if (countryDetails) {
                const guardianCountryCodeCountryCodeObj = {
                    value: val,
                    label: countryDetails.label
                }
                setGuardianCountryCode(guardianCountryCodeCountryCodeObj)
            }
        } else if (source === listOfSections.guardianDetails.guardianContactNumber) {
            setGuardianContactNumber(formatNumberInputWithSpaceAfter5Numbers(val))
        } else if (source === listOfSections.bloodGroup) {
            const bloodGrpObj = {
                value: val,
                label: val
            }
            setBloodGroup(bloodGrpObj)
        } else if (source === listOfSections.underGraduateDegree) {
            const uGDegreeObj = {
                value: val,
                label: val
            }
            setUgDegree(uGDegreeObj)
        } else if (source === listOfSections.underGraduateInstitute.underGraduateInstituteName) {
            setUnderGraduateInstituteNameInstituteName(val)
        } else if (source === listOfSections.underGraduateInstitute.underGraduateInstituteAddress) {
            setUnderGraduateInstituteAddressInstituteAddress(val)
        } else if (source === listOfSections.registrationNumber) {
            setRegistrationNumber(val)
        } else if (source === listOfSections.passingYear) {
            const passingYearObj = {
                value: val,
                label: val
            }
            setPassingYear(passingYearObj)
        } else if (source === listOfSections.aadharCard) {
            setAadharCard(val)
        } else if (source === listOfSections.panCard) {
            setPanCard(val)
        } else if (source === listOfSections.signature.signature) {
            setSignature(val)
        } else if (source === listOfSections.signature.placeOfSignature) {
            setPlaceOfSignature(val)
        } else if (source === listOfSections.signature.dateOfSignature) {
            setDateOfSignature(val)
        }
    };

    const handleSubmit = async (source: string) => {
        setErrMsg('')
        setIsSubmitBtnLoading(true)
        // debugger
        if (source === listOfSections.guardianName) {
            const updateObj = {
                guardianName: guardianName,
                guardianNameStatus: idVerificationProofStatus.inProgress
            }
            // console.log(profileDetails.bssForm.guardianNameStatus)
            // debugger
            handleSubmit3(updateObj)
        } else if (source === listOfSections.bloodGroup) {
            let updateObj = {
                bloodGroup: null
            }
            if (bloodGroup && bloodGroup.value) {
                updateObj.bloodGroup = bloodGroup.value
            }
            handleSubmit3(updateObj)
        } else if (source === listOfSections.guardianDetails.guardianContactNumber) {
            const contactDetails = handleContactDetailsSubmit()
            if (Object.entries(contactDetails).length > 0) {
                handleSubmit3(contactDetails)
            } else {
                setErrMsg(common.statusText.pleaseGiveInput2)
                setIsSubmitBtnLoading(false)
            }
        } else if (source === listOfSections.underGraduateDegree) {
            let updateObj = {
                underGraduateDegree: null,
                underGraduateDegreeStatus: idVerificationProofStatus.inProgress
            }
            if (ugDegree && ugDegree.value) {
                updateObj.underGraduateDegree = ugDegree.value
            }
            handleSubmit3(updateObj)
        } else if (source === listOfSections.underGraduateInstitute.underGraduateInstituteName) {
            let updateObj: any = {
                underGraduateInstituteName: null,
                underGraduateInstituteAddress: null,
                underGraduateInstituteNameStatus: idVerificationProofStatus.inProgress,
                underGraduateInstituteAddressStatus: idVerificationProofStatus.inProgress,
            }
            if (underGraduateInstituteName) {
                updateObj.underGraduateInstituteName = underGraduateInstituteName
            }
            if (underGraduateInstituteAddress) {
                updateObj.underGraduateInstituteAddress = underGraduateInstituteAddress
            }
            handleSubmit3(updateObj)
        } else if (source === listOfSections.registrationNumber) {
            let updateObj: any = {
                registrationNumber: null,
                registrationNumberStatus: idVerificationProofStatus.inProgress
            }
            if (registrationNumber) {
                updateObj.registrationNumber = registrationNumber
            }
            handleSubmit3(updateObj)
        } else if (source === listOfSections.passingYear) {
            let updateObj = {
                passingYear: null,
                passingYearStatus: idVerificationProofStatus.inProgress
            }
            if (passingYear && passingYear.value) {
                updateObj.passingYear = passingYear.value
            }
            handleSubmit3(updateObj)
        } else if (source === listOfSections.aadharCard) {
            if (aadharCard) {
                handleImgUpload(listOfSections.aadharCard, aadharCard)
            } else {
                setErrMsg(common.statusText.pleaseGiveInput)
                setIsSubmitBtnLoading(false)
            }
        } else if (source === listOfSections.panCard) {
            if (panCard) {
                handleImgUpload(listOfSections.panCard, panCard)
            } else {
                setErrMsg(common.statusText.pleaseGiveInput)
                setIsSubmitBtnLoading(false)
            }
        } else if (source === listOfSections.otherDocs) {
            if (otherDocs) {
                handleImgUpload(listOfSections.otherDocs, otherDocs)
            } else {
                let updateObj = {
                    otherDocs: null
                }
                handleSubmit3(updateObj)
            }
        } else if (source === listOfSections.signature.signature) {
            if (signature && placeOfSignature && dateOfSignature && bssAcknowledged) {
                handleImgUpload(listOfSections.signature.signature, signature)
            } else {
                if(!signature || !placeOfSignature || !dateOfSignature){
                    setErrMsg(common.statusText.pleaseGiveInput2)
                } else {
                    setErrMsg(common.statusText.pleaseGiveInput4)
                }
                setIsSubmitBtnLoading(false)
            }
        }
    }

    const handleContactDetailsSubmit = () => {
        let contactDetails = {}
        const countryDetails = getCountryByValue(guardianCountryCode.value)
        if (countryDetails) {
            // if ((guardianContactNumber != "" && guardianContactNumber.length >= 10) && countryDetails) {
            contactDetails = {
                guardianCountryCode: "+" + guardianCountryCode.value,
                guardianContactNumber: undo_formatNumberInputWithSpaceAfter5Numbers(guardianContactNumber),
            };
        }
        return contactDetails
    }


    const handleImgUpload = async (source: string, imgBase64_OR_imgUrl: any) => {
        let isImgNotChanged = false
        // debugger
        if (profileDetails.bssForm) {
            let exit = false
            if (source === listOfSections.aadharCard
                && profileDetails.bssForm.aadharCard
                && imgBase64_OR_imgUrl === profileDetails.bssForm.aadharCard) {
                // exit = true
                isImgNotChanged = true
            } else if (source === listOfSections.panCard
                && profileDetails.bssForm.panCard
                && imgBase64_OR_imgUrl === profileDetails.bssForm.panCard) {
                // exit = true
                isImgNotChanged = true
            } else if (source === listOfSections.otherDocs
                && profileDetails.bssForm.otherDocs
                && imgBase64_OR_imgUrl === profileDetails.bssForm.otherDocs) {
                // exit = true
                isImgNotChanged = true
            } else if (source === listOfSections.signature.signature) {
                if (profileDetails.bssForm.signature
                    && imgBase64_OR_imgUrl === profileDetails.bssForm.signature) {
                    isImgNotChanged = true
                    if (profileDetails.bssForm.placeOfSignature
                        && placeOfSignature === profileDetails.bssForm.placeOfSignature
                        && profileDetails.bssForm.dateOfSignature
                        && dateOfSignature === profileDetails.bssForm.dateOfSignature
                        && bssAcknowledged === profileDetails.bssForm.bssAcknowledged) {
                        // exit = true
                    }
                }
            }
            if (exit) {
                setIsSubmitBtnLoading(false)
                dispatch(setProfileStepNo(profileStepNo + 1));
                return
            }
        }



        let folderPath = ""
        let imgName = ""
        if (source === listOfSections.aadharCard) {
            folderPath = FOLDER_PATHS.BSS_AADHAR_CARDS
            imgName = FILE_NAME.AADHAR_CARD_ANME
        } else if (source === listOfSections.panCard) {
            folderPath = FOLDER_PATHS.BSS_PAN_CARDS
            imgName = FILE_NAME.PAN_CARD_ANME
        } else if (source === listOfSections.otherDocs) {
            folderPath = FOLDER_PATHS.BSS_OTHER_DOCS
            imgName = FILE_NAME.OTHER_DOC
        } else if (source === listOfSections.signature.signature) {
            folderPath = FOLDER_PATHS.BSS_SIGNATURES
            imgName = FILE_NAME.SIGNATURES
        }

        try {
            if (isImgNotChanged) {
                let updateObj: any = {}
                if (source === listOfSections.aadharCard) {
                    updateObj["aadharVerificationStatus"] = idVerificationProofStatus.inProgress
                }
                else if (source === listOfSections.panCard) {
                    updateObj["panVerificationStatus"] = idVerificationProofStatus.inProgress
                }
                else if (source === listOfSections.otherDocs) {
                    updateObj["otherDocsVerificationStatus"] = idVerificationProofStatus.inProgress
                }
                else if (source === listOfSections.signature.signature) {
                    updateObj["signatureVerificationStatus"] = idVerificationProofStatus.inProgress
                    updateObj["placeOfSignatureStatus"] = idVerificationProofStatus.inProgress
                    updateObj["signature"] = imgBase64_OR_imgUrl
                    updateObj["bssAcknowledged"] = bssAcknowledged
                    updateObj["placeOfSignature"] = placeOfSignature ? placeOfSignature : null
                    let dateOfSignatureToSave = null
                    if (dateOfSignature) {
                        dateOfSignatureToSave = moment(dateOfSignature).format("YYYY-MM-DD");
                    }
                    updateObj["dateOfSignature"] = dateOfSignatureToSave
                }
                if (Object.entries(updateObj).length > 0) {
                    handleSubmit3(updateObj)
                } else {
                    setErrMsg(common.statusText.issueInUpdating)
                    console.log("handleImgUpload", "issueInUpdating");
                }
            }
            else {
                const imgBlob = dataURLtoBlob(imgBase64_OR_imgUrl)
                if (imgBlob.status && imgBlob.blob) {
                    const response = await uploadImage(imgBlob.blob, folderPath, imgName);
                    if (response.status) {

                        let updateObj: any = {}
                        if (source === listOfSections.aadharCard) {
                            updateObj["aadharCard"] = response.data.cloudFrontUrl
                            updateObj["aadharVerificationStatus"] = idVerificationProofStatus.inProgress
                        } else if (source === listOfSections.panCard) {
                            updateObj["panCard"] = response.data.cloudFrontUrl
                            updateObj["panVerificationStatus"] = idVerificationProofStatus.inProgress
                        } else if (source === listOfSections.otherDocs) {
                            updateObj["otherDocs"] = response.data.cloudFrontUrl
                            updateObj["otherDocsVerificationStatus"] = idVerificationProofStatus.inProgress
                        } else if (source === listOfSections.signature.signature) {
                            updateObj["signatureVerificationStatus"] = idVerificationProofStatus.inProgress
                            updateObj["placeOfSignatureStatus"] = idVerificationProofStatus.inProgress        
                            updateObj["signature"] = response.data.cloudFrontUrl
                            updateObj["bssAcknowledged"] = bssAcknowledged
                            updateObj["placeOfSignature"] = placeOfSignature ? placeOfSignature : null
                            let dateOfSignatureToSave = null
                            if (dateOfSignature) {
                                dateOfSignatureToSave = moment(dateOfSignature).format("YYYY-MM-DD");
                            }
                            updateObj["dateOfSignature"] = dateOfSignatureToSave
                        }

                        if (Object.entries(updateObj).length > 0) {
                            handleSubmit3(updateObj)
                        } else {
                            setErrMsg(common.statusText.errorUploadingImage)
                            console.log("handleImgUpload", "issue in converting base64 to blob");
                        }

                    }
                } else {
                    setErrMsg(common.statusText.errorUploadingImage)
                    console.log("handleImgUpload", "issue in converting base64 to blob");
                }
            }
        } catch (error) {
            setErrMsg(common.statusText.errorUploadingImage)
            console.log("handleImgUpload", error);
        } finally {
            setIsSubmitBtnLoading(false);
        }
    }


    const handleSubmit3 = async (updatedFields: any) => {
        const fieldsToUpdate: any = {};
        let anyFieldChanged = false;
        let anyValueEmpty = false
        let specialFalgForEmptyVals = false
        // debugger
        for (const source in updatedFields) {
            if (Object.prototype.hasOwnProperty.call(updatedFields, source)) {
                const newValue = updatedFields[source];
                const bss = profileDetails.bssForm

                let currentValue = '';
                if (bss && bss[source]) {
                    currentValue = bss[source];
                }

                // const currentValue = bss[source];

                const emptyCheckValidataion_ = doEmptyCheckValidataion(source)
                // debugger
                if (emptyCheckValidataion_) {
                    if (newValue === null || newValue === "") {
                        anyValueEmpty = true
                    }
                    if ((newValue !== null && newValue !== "") && newValue !== currentValue) {
                        fieldsToUpdate[source] = newValue;
                        anyFieldChanged = true;
                    }
                } else {
                    if (newValue !== currentValue) {
                        fieldsToUpdate[source] = newValue;
                        anyFieldChanged = true;
                    }
                }

                if ((updatedFields.hasOwnProperty(listOfSections.underGraduateInstitute.underGraduateInstituteName)
                    && updatedFields.hasOwnProperty(listOfSections.underGraduateInstitute.underGraduateInstituteAddress))
                    && anyValueEmpty) {
                    specialFalgForEmptyVals = true
                }

                if ((updatedFields.hasOwnProperty(listOfSections.guardianDetails.guardianContactNumber)
                    && updatedFields.hasOwnProperty(listOfSections.guardianDetails.guardianCountryCode))
                    && anyValueEmpty) {
                    specialFalgForEmptyVals = true
                }

            }
        }
        // debugger
        if (!specialFalgForEmptyVals && Object.keys(fieldsToUpdate).length > 0) {
            const updateUserProfileApiCallStatus = await updateUserBssFormApiCall(fieldsToUpdate);

            if (updateUserProfileApiCallStatus.status) {
                dispatch(setProfileStepNo(profileStepNo + 1));
                const mergedObj = {
                    ...profileDetails, // 1. Copy all top-level properties from objB
                    bssForm: {
                        ...profileDetails.bssForm, // 2. Copy all existing properties from objB.bssForm
                        ...fieldsToUpdate           // 3. Spread all properties from objA here, overwriting duplicates
                    }
                }
                dispatch(updateProfileFields(mergedObj));
            } else {
                setErrMsg(common.statusText.issueInUpdating);
            }
        } else {
            if (anyValueEmpty) {
                setErrMsg(common.statusText.pleaseGiveInput2);
            } else {
                dispatch(setProfileStepNo(profileStepNo + 1));
            }
        }

        setIsSubmitBtnLoading(false);
    };

    const doEmptyCheckValidataion = (fieldName: string) => {
        let doValidation = false
        if (fieldName === listOfSections.guardianName
            || fieldName === listOfSections.bloodGroup
            || fieldName === listOfSections.underGraduateDegree
            || fieldName === listOfSections.guardianDetails.guardianContactNumber
            || fieldName === listOfSections.guardianDetails.guardianCountryCode
            || fieldName === listOfSections.underGraduateInstitute.underGraduateInstituteAddress
            || fieldName === listOfSections.underGraduateInstitute.underGraduateInstituteName
            || fieldName === listOfSections.registrationNumber
            || fieldName === listOfSections.passingYear
            || fieldName === listOfSections.signature.signature
            || fieldName === listOfSections.signature.placeOfSignature
            || fieldName === listOfSections.signature.dateOfSignature
            || fieldName === listOfSections.signature.bssAcknowledged
        ) {
            doValidation = true
        }
        return doValidation
    }




    // ============ START : code for toast ============
    const closeToast = () => {
        setToastVisible(false);
    };
    const showToast = () => {
        setToastVisible(true);
        setTimeout(() => {
            setToastVisible(false);
            dispatch(setProfileStepNo(profileStepNo + 1));
        }, 3000);
    };
    // ============ END : code for toast ============
    return (
        <>
            <BssDetailsView
                errMsg={errMsg}
                isSubmitBtnLoading={isSubmitBtnLoading}
                handleInputChange={handleInputChange}
                handleSubmit={handleSubmit}
                profileStepNo={profileStepNo}
                guardianName={guardianName}
                handleOnCheckBoxChanged={handleOnCheckBoxChanged}
                guardianCountryCode={guardianCountryCode}
                guardianContactNumber={guardianContactNumber}
                bloodGroup={bloodGroup}
                ugDegree={ugDegree}
                underGraduateInstituteName={underGraduateInstituteName}
                underGraduateInstituteAddress={underGraduateInstituteAddress}
                registrationNumber={registrationNumber}
                passingYear={passingYear}
                aadharCard={aadharCard}
                panCard={panCard}
                otherDocs={otherDocs}
                signature={signature}
                placeOfSignature={placeOfSignature}
                dateOfSignature={dateOfSignature}
                bssAcknowledged={bssAcknowledged}
            />

            <Toast
                message={common.statusText.toastProfileSubmittedSuccessfully}
                visible={toastVisible}
                onClose={closeToast}
                bgColor="#EEFFE1"
                textColor="#397D05"
                crossColor="#2C2C2C"
                fontWeight="500"
                fontSize="15px"
            />

        </>
    );
}
